import type { FunctionComponent } from 'react';

import { CopyConfirmedIcon, CopyIcon } from '../../../icons/icons';

type ClipBoardIconProps = {
  isCopied?: boolean;
  getCopiedState?: () => boolean;
};

export const ClipBoardIcon: FunctionComponent<ClipBoardIconProps> = ({
  isCopied,
  getCopiedState
}) => {
  const copied = getCopiedState ? getCopiedState() : isCopied;

  return !copied ? (
    <CopyIcon size="1em" />
  ) : (
    <CopyConfirmedIcon fontSize="inherit" color="success" />
  );
};
